export const achieversHeroText = {
  en: {
    title: "Shaping Students for Tomorrow’s Careers",
    subtitle:
      "Your journey is unique. We help you turn your strengths, passions, and experiences into a compelling story.",
  },

  vi: {
    title: "Định Hình Hành Trình Nghề Nghiệp Tương Lai",
    subtitle:
      "Mỗi hành trình đều khác biệt. Chúng tôi giúp bạn biến điểm mạnh, đam mê và trải nghiệm của mình thành một câu chuyện nghề nghiệp ghi nhận từ trong tim.",
  },
};
